import { Action } from '../../../common/actions/core/action';
import { Date } from '../../../common/services/package/package.model';

export class OpenStudentSuccessfulAction implements Action {
  constructor(
    public packageId: String,
    public endDate: Date
  ) {}
}



// WEBPACK FOOTER //
// src/app/components/student/successful/successful.action.ts